<div class="modal-clean modal-clean--wide modal-stripe">
    <div class="modal-clean__close" (click)="close()">
        <fa-icon [icon]="['tg', 'times-alt']"></fa-icon>
    </div>
    <div class="modal-clean__content modal-stripe__content">
        <div #paymentElement></div>
    </div>
</div>
